<template>
    <div class="bindPage">
        <div class="layout">
            <v-search
                :formContent="formContent"
                :SearchForm="SearchForm"
                :inline="true"
                :optareBtn="optareBtn"
                :treePathObj="treePathObj"
                @resetFn="resetFn"
                @confirmFn="getListFn"
                @searchFn="getListFn"
                @ruleFn="ruleFn"
                @netFn="netFn"
                @stopFn="stopFn"
            />
            <div class="componentPage">
                <unBindTable
                    v-bind="$attrs"
                    :loading="loading"
                    :shiquArray="shiquArray"
                    :tableData="tableData"
                    @choozeTable="choozeTable"
                    @stopUseFn="stopUseFn"
                    @stopAlarmFn="stopAlarmFn"
                    @configFn="configFn"
                    @detailFn="detailFn"
                />
                <Pagination class="pagination" :total="total" :page.sync="SearchForm.iDisplayStart" :limit.sync="SearchForm.iDisplayLength" @pagination="getListFn"></Pagination>
            </div>
        </div>
        <!-- 上报规则 -->
        <ruleDialog :isShow.sync="isShow" ref="rule" :choozeTableData="choozeTableData" />
        <!-- 网络参数 -->
        <netDialog :isShowNet.sync="isShowNet" ref="net" :choozeTableData="choozeTableData" />
        <!-- 配置 -->
        <configDialog :isShowConfig.sync="isShowConfig" :rowData="rowData" :title="title" v-bind="$attrs" ref="config" v-if="isShowConfig" />
        <!-- 详情 -->
        <detailDialog :isDetailShow.sync="isDetailShow" v-bind="$attrs" />
    </div>
</template>

<script>
import getAllTreePath from '@/utils/getAllTreePath.js'
import bus from '@/utils/bus.js'
import qs from 'qs'

import unBindTable from './unBindTable.vue'
import ruleDialog from '../components/ruleDialog.vue'
import netDialog from '../components/netDialog.vue'
import configDialog from '../components/ConfigDialog.vue'
import detailDialog from '@/components/dialog/displayDetail/displayDetailDialog.vue'

import { displayList, contentList, displayEdit, displayUpdateAppConfig } from '@/api/modules/display.js'
import { getIsPlatform, getPermission } from '@/utils/permission'
import { SCHEDU_SEARCH_CONFIG_STATUS } from '@/common/schedule/Search'

export default {
  mixins: [getAllTreePath],
  components: {
    unBindTable,
    ruleDialog,
    netDialog,
    configDialog,
    detailDialog
  },
  props: {
    selectDeviceType: {
      type: Array
    }
  },
  watch: {
    selectDeviceType: {
      handler (newval) {
        this.formContent[1].selectParam = newval
      },
      immediate: true
    }
  },
  computed: {
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      return getPermission()
    }
  },
  data () {
    return {
      formContent: [
        {
          id: 1,
          text: 'device.display_name',
          type: 'input',
          paramsName: 'name',
          isChooze: true
        },
        {
          id: 6,
          text: 'device.display_type',
          type: 'select',
          paramsName: 'type',
          isChooze: false,
          selectParam: []
        },
        {
          id: 2,
          text: 'device.running_status',
          type: 'select',
          paramsName: 'status',
          isChooze: false,
          selectParam: [
            {
              value: '',
              icon: 'el-icon-thumb',
              label: 'public.please'
            },
            {
              value: 0,
              icon: 'iconfont icon-wu-WiFi',
              label: 'selectMsg.Offline'
            },
            {
              value: 1,
              icon: 'iconfont icon-wifi',
              label: 'selectMsg.Online'
            }
          ]
        },
        SCHEDU_SEARCH_CONFIG_STATUS,
        {
          id: 4,
          text: 'device.display_number',
          type: 'input',
          paramsName: 'terminalCode',
          isChooze: false
        }
      ],
      SearchForm: {
        name: null,
        status: '',
        scopeName: null,
        terminalCode: null,
        configStatus: null,
        type: '',
        iDisplayStart: 0,
        iDisplayLength: 15
      },
      total: 0,
      loading: false,
      tableData: [],
      title: '',
      isShow: false,
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.stop',
          method: 'stopFn'
        },
        {
          id: 2,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.escalation_rules',
          method: 'ruleFn'
        },
        {
          id: 3,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.net_param',
          method: 'netFn'
        }
      ],
      shiquArray: [],
      isShow: false,
      choozeTableData: [],
      // 网络参数
      isShowNet: false,
      // 配置
      isShowConfig: false,
      title: '',
      rowData: {},
      // 详情
      shiquArray: [],
      isDetailShow: false,
      detailObj: {},
      deviceType: {},
      detailNetObj: {},
      deviceProperty: {}
    }
  },
  created () {
    this.contentListFn()
  },
  mounted () {
    bus.$off('nodeClickFn')
    bus.$on('nodeClickFn', row => {
      // 获取完整的路径
      this.getAllPath(row)
      this.treeClickSearchFn(row)
    })
    if (this.sysAdmin === 'noSysNoAdmin') {
      this.optareBtn.splice(1, 2)
    }
    if (getIsPlatform()) {
      this.SearchForm.scopeName = this.$store.state.SchemaTree[1].label
      this.treePathObj = this.$store.state.SchemaTree[1].label
    } else {
      this.SearchForm.scopeName = this.$store.state.SchemaTree[0].label
      this.treePathObj = this.$store.state.SchemaTree[0].label
    }
    this.getListFn()
  },
  methods: {
    /** 点击树形查询 */
    treeClickSearchFn (row) {
      if (row.id === 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = null
      }
      // 一级范围
      else if (row.level === 0 && row.id !== 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = row.label
      } else {
        this.SearchForm.scopeName = null
        this.SearchForm.sceneId = row.sceneId
      }
      this.getListFn()
    },
    /** 时区 */
    contentListFn () {
      if (this.shiquArray.length > 0) return
      contentList({ code: 'ADMIN_CONFIG_LABEL_NOTICE_ZONE', type: 0 }).then(({ result }) => {
        this.shiquArray = result
      })
    },
    /** 分页 */
    getListFn () {
      this.loading = true
      displayList(this.SearchForm, 'unbind')
        .then(({ result, pageInfo }) => {
          this.tableData = result
          this.total = pageInfo.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetFn () {
      this.SearchForm = {
        name: null,
        status: '',
        scopeName: null,
        terminalCode: null,
        configStatus: null,
        type: '',
        iDisplayStart: 0,
        iDisplayLength: 15
      }
      if (getIsPlatform()) {
        this.SearchForm.scopeName = this.$store.state.SchemaTree[1].label
        this.treePathObj = this.$store.state.SchemaTree[1].label
      } else {
        this.SearchForm.scopeName = this.$store.state.SchemaTree[0].label
        this.treePathObj = this.$store.state.SchemaTree[0].label
      }
      bus.$emit('initTree')
      this.getListFn()
    },
    choozeTable (row) {
      this.choozeTableData = row
    },
    /** 上报规则 */
    ruleFn () {
      if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'))
      this.isShow = true

      this.$nextTick(() => {
        this.$refs.rule.clearValidate()
      })
    },
    /** 网络参数 */
    netFn () {
      if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'))
      this.isShowNet = true
      this.$nextTick(() => {
        this.$refs.net.clearValidate()
      })
    },
    /** 多条停用 */
    stopFn () {
      if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'))
      const idList = this.choozeTableData.map(item => item.id)
      const query = qs.stringify({ ids: idList.join(','), status: 2 })
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          displayEdit(query, 'unused').then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 单条网关停用 */
    stopUseFn (row) {
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          const query = qs.stringify({ ids: row.id, status: 2 })
          displayEdit(query, 'unused').then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 暂停报警 */
    stopAlarmFn (row) {
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(res => {
          displayUpdateAppConfig({ idList: [row.id], alarmOn: 0 }).then(async ({ result, state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 配置 */
    configFn (row) {
      this.rowData = { ...row }
      this.isShowConfig = true
      this.title = $t('integration.configuration_information')
      this.$nextTick(() => {
        this.$refs.config.activeName = 'ConfigRule'
      })
    },
    /** 详情 */
    detailFn (row) {
      this.isDetailShow = true
      bus.$emit('displayParam', row.id, row.name, row.scopeName)
    }
  }
}
</script>

<style lang="scss" scoped>
.bindPage {
    width: 100%;
    height: 100%;
    padding-right: 15px;
    box-sizing: border-box;

    .layout {
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
    }

    .componentPage {
        flex: 1;

        .pagination {
            padding-top: 0;
            padding-right: 15px !important;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
}
</style>
